const config = __CONFIG__

const getLoginUrl = () => {
  if (config.LOGIN_URL.indexOf('/aaa') !== -1) {
    return `${config.LOGIN_URL}?state=${encodeURIComponent(window.location.href)}`
  }
  return `${config.LOGIN_URL}/signin?nv_redirect=${encodeURIComponent(window.location.href)}`
}

const goToLogin = () => {
  window.location.href = getLoginUrl()
}

export default {
  getLoginUrl,
  goToLogin
}
